export const uk = {
    'add-entity': 'Добавить',
    'agency-clients': 'Список клиентов агентства',
    'all-clients': 'Все клиенты',
    campaigns: 'Кампании',
    'client-representatives': 'Зарегистрированные представители',
    creatives: 'Креативы для смарт-баннеров',
    edit: 'Редактирование',
    feeds: 'Фиды',
    info: 'Информация',
    'internationalization-interface': 'Интерфейс интернационализации',
    library: 'Библиотека',
    'minus-keywords-library': 'Минус-фразы',
    'mobile-apps': 'Мобильные приложения',
    'order-reports': 'Заказ отчетов',
    'phrases-positions-monitoring': 'Мониторинг изменений позиций по фразам',
    'price-packages-grid': 'Пакеты',
    recommendations: 'Рекомендации',
    reports: 'Отчёты',
    'retargeting-and-audiences': 'Ретаргетинг и аудитории',
    'statistic-by-all-campaigns': 'Статистика по всем кампаниям',
    'statistic-by-all-old-campaigns': 'Статистика по старым кампаниям в у.е.',
    tools: 'Инструменты',
    'turbo-pages': 'Конструктор Турбо-страниц',
    'upload-documents': 'Загрузить документы'
};
